import { render, staticRenderFns } from "./IconSettings.vue?vue&type=template&id=d796b696"
var script = {}
import style0 from "./IconSettings.vue?vue&type=style&index=0&id=d796b696&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports